import qs from 'qs';

import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQueryWithReauth } from './baseQueryWithReauth';
import type { RootState } from './index';

/**
 * Configures an empty api with the message delivery options as root base url.  Endpoints will be injected via rtk query generation.
 */
export const sageBaseInsightsEngineApi = createApi({
    baseQuery: createBaseQueryWithReauth({
        baseUrl: import.meta.env.VITE_SAGE_INSIGHTS_ENGINE_BASE_URL,
        timeout: 10_000,

        // See https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#setting-default-headers-on-requests
        prepareHeaders: (headers, { getState }) => {
            const rootState: RootState = getState() as RootState;

            const bearerToken = rootState.authConfig?.bearerToken;
            if (bearerToken) {
                const authHeader = (bearerToken as String).toLowerCase().startsWith('bearer')
                    ? bearerToken
                    : `Bearer ${bearerToken}`;

                headers.set('Authorization', authHeader);
            }

            const profileRid = rootState.appConfig?.staffMemberId;
            if (profileRid) {
                headers.set('x-sage-profile-rid', profileRid);
            }

            return headers;
        },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    }),
    endpoints: () => ({}),
    tagTypes: ['insights', 'workflows', 'actions', 'rules'],
    reducerPath: 'sageInsightsEngineApi',
});
